<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" :to="'cash-transfer/create'" class="float-right btn-custom"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
    </b-row>

      <b-row class="mt-3 mb-5">
      <b-col md="5">
        <div>
          <b-form-datepicker v-model="filter.cash_date" locale="en"></b-form-datepicker>
          </div>
      </b-col>
      <b-col></b-col>
      <b-col></b-col>
    </b-row>
    <div class="table-responsive table-striped" style="max-width: 100%;">
          <table class="w-100">
            <thead class="table-bordered text-center">
              <tr>
                <th width="180">No Transaction</th>
                <th width="140">Date</th>
                <th width="120">Acc Code</th>
                <th width="250">Account Name</th>
                <th width="364">Description</th>
                <th width="180">Debit</th>
                <th width="180">Credit</th>
                <th></th>
              </tr>
            </thead>
            <div v-if="isLoading">
           <div class="text-center justify-content-center" style="margin: 0 auto;">
               <b-spinner small type="grow" label="Small Spinner"></b-spinner>
               <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
               <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
           </div>
          </div>
            <tbody v-else class="table-bordered mt-3">
              <tr v-for="cash in model.cashIn" :key="cash.uuid" class="mt-2">
                <!-- no transaction -->
                <td width="180">
                  <p>
                  {{cash.no !==null ? cash.no : '-'}}
                  </p>
                </td>
                <td width="140">
                  <p class="text-center">
                  {{cash.date !==null ? new Date(cash.date).toLocaleDateString() : '-'}}
                  </p>
                </td>
                <td width="120" >
                  <div v-for="tran in cash.transaction" :key="tran.uuid">
                    <p class="m-0 p-0 text-center">
                  {{tran.account !== null ? tran.account.journalAccountCode : '-'}}
                    </p>
                  </div>
                </td>
                <td width="250">
                  <div v-for="tran in cash.transaction" :key="tran.uuid">
                    <p class="m-0 p-0">
                    {{tran.account !== null ? tran.account.journalAccountName : '-'}}
                    </p>
                  </div>
                </td>
                <td width="364">
                  <div v-for="tran in cash.transaction" :key="tran.uuid" class="d-flex font-weight-light">
                     {{tran.note}}
                  </div>
                </td>
                <td width="120" class="money">
                  <div v-for="tran in cash.transaction" :key="tran.uuid" class="text-right">
                      {{formatPrice(tran.debit)}}
                  </div>
                </td>
                <td width="120" class="money">
                  <div v-for="tran in cash.transaction" :key="tran.uuid" class="text-right">
                      {{formatPrice(tran.credit)}}
                  </div>
                </td>
                <td width="40" class="text-center">
                  <a
                        v-if="canShowRoutePath"
                        v-b-tooltip.hover.left
                        title="Details"
                        class="btn-op icon-info mr-1"
                        :href="'/#/accounting/cash-transfer' + '/' + cash.uuid"
                      ></a>
                      <a
                        v-else
                        v-b-tooltip.hover.left
                        title="Details"
                        class="btn-op icon-info mr-1"
                        :href="'#' + $route.path + '/' + cash.uuid"
                      ></a>
                  <!-- <b-icon icon="exclamation-circle-fill" variant="primary" class="pointer"></b-icon> -->
                   <a v-b-tooltip.hover.topright  v-on:click.stop.prevent="doDeleteData(cash.uuid)" title="Delete" class="btn-op icon-delete ml-1"></a>
                </td>
              </tr>
            </tbody>
               <tbody v-if="model.cashIn.length === 0" class="text-center">no data</tbody>
          </table>
        </div>
   <!-- <paginated-table :data-columns="columns" :data-key="dataKey" :data-url="apiUrl.cashIn"
    ></paginated-table> -->
   <b-row v-if="page > 15">
      <b-col md="7"></b-col>
      <b-col md="3">   </b-col>
      <b-col md="2">
        <!-- <div class="d-flex" style="align-items: center;">
          <div></div>
          <b-button @click="model.paginate --" v-if="buttonPrev" size="sm" 
           variant="info" class="mt-3 mr-3">prev</b-button> <p class="mt-4"> {{page}} / {{pageSize !== null ? pageSize : pageSize}} </p> 
          <b-button @click="model.paginate ++" v-if="buttonNext" size="sm" variant="info" class="mt-3 ml-3"> next</b-button>
          </div> -->
      </b-col>
    </b-row>
    <div v-if="page > 15" class="d-flex w-100 float-right justify-content-end" style="align-items: center;">
        <div></div>
        <b-button @click="model.paginate --" v-if="buttonPrev" size="sm" 
         variant="info" class="mt-3 mr-3">prev</b-button> <p class="mt-4"> {{page}} / {{pageSize}} </p> 
        <b-button @click="model.paginate ++" v-if="buttonNext" size="sm" variant="info" class="mt-3 ml-3"> next</b-button>
      </div>

  </b-card>
</template>

<script>
// import PaginatedTable from '../../../components/PaginatedTable.vue'
export default {
  name: 'cashin-index',
  components: {},
  data () {
    return {
      isLoading: false,
      buttonPrev: false,
      buttonNext: true,
      // rows: 0,
      currentPage: 1,
      pageSize: null ,
      page: 1,
      perPage: 10,
      index: 0,
      dataKey: 'cash',
      apiUrl : {
        cashTransfer: window.AppConfig.apiUrl + 'cash?cash_type=CT'
      },
      model:{
        cashIn: [],
        paginate: 1,
      },

      filter: {
        cash_date: null,
      },
       canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
    }
  },
  watch: {
    'model.paginate'(value){
        this.getJournalData(value)
    },

    'filter.cash_date'(date){
      this.getCashPerDate(date)
      console.log('date', date);
    }
  },
  mounted () {
    this.getJournalData()
    this.trigerFilter()
  },

  methods: {
    getJournalData(pages){
       this.isLoading = true
       if(pages === undefined){
         this.$http.get(this.apiUrl.cashTransfer + '&limit=' + this.perPage + '&page=1').then((response)=> {
         this.model.cashIn = response.data._embedded.cash.map((p) => ({
          no: p.cashNumber,
          date: p.cashDate,
          uuid: p.uuid,
          transaction: p.cashTransaction.map(transaction=>({
             debit: transaction.cashTransactionDebit,
             credit: transaction.cashTransactionCredit,
             note: transaction.cashTransactionNote,
             account: transaction.journalAccount
             }))
        }));
        this.isLoading = false
        this.rows = response.data.total_items
        console.log('response is:',this.model.cashIn);
      })
       } else {
         this.$http.get(this.apiUrl.cashTransfer + '?limit=' + this.perPage + '&page=' + pages).then((response)=> {
           this.model.cashIn = response.data._embedded.cash.map((p) => ({
             no: p.cashNumber,
             date: p.cashDate,
             uuid: p.uuid,
             transaction: p.cashTransaction.map(transaction=>({
               debit: transaction.cashTransactionDebit,
               credit: transaction.cashTransactionCredit,
               note: transaction.cashTransactionNote,
               account: transaction.journalAccount
             }))
           }));
           this.rows = response.data.total_items
           this.pageSize = response.data.page_count
           this.page = response.data.page
           if(this.model.paginate === response.data.page_count){
             this.buttonNext = false;
             this.buttonPrev = true
           } else if (this.model.paginate === 1) {
             this.buttonPrev = false
             this.buttonNext = true
           } else {
             this.buttonPrev = true
             this.buttonNext = true
           }
           console.log('response is:',this.model.journals);
           this.isLoading = false
         })
         
       }
    },

     trigerFilter(){
      if(this.filter.cash_date !== null ){
        this.getCashPerDate()
      }
    },

    getCashPerDate(date){
      this.$http.get(this.apiUrl.cashTransfer + '&cash_date=' + date).then((response)=> {
        this.isLoading = true
        this.model.cashIn = response.data._embedded.cash.map((p) => ({
          no: p.cashNumber,
          date: p.cashDate,
          uuid: p.uuid,
          transaction: p.cashTransaction.map(transaction=>({
             debit: transaction.cashTransactionDebit,
             credit: transaction.cashTransactionCredit,
             note: transaction.cashTransactionNote,
             account: transaction.journalAccount
             }))
        }));
        this.isLoading = false
        this.rows = response.data.total_items
        this.isLoading = false
      })
    },

      doDeleteData(uuid){
      this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this data!',
          icon: "warning",
          buttons: true,
          dangerMode: true,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            this.$http.delete(window.AppConfig.apiUrl + 'cash' + '/' + uuid).then(response => {
              this.$store.dispatch('notification/success', 'Successfully deleted.')
              this.getJournalData()
            }).catch(error => {
              this.$store.dispatch('notification/error', 'Failed To Delete Data.')
              window.consoleLog(error)
            })
          }
        })
    },

   formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('DD MMM YYYY HH:mm');
      } else {
        return '-';
      }
    },

  },


}
</script>

<style lang="css">

</style>